import { API_VERSION, SERVER_URL } from "../consts";
import logger from "./Logger";

export const calculateCommuteAPI = async (locations, destinations, departureTime) => {
  const data = [{ locations: locations }, { constraints: destinations }, { departureTime: departureTime }];
  console.log("This is the data sent to the backend - ", data);
  let dataResponse;
  const queryString = data.map((obj) => `data=${encodeURIComponent(JSON.stringify(obj))}`).join("&");

  await fetch(`${SERVER_URL}${API_VERSION}/drive-route?${queryString}`, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "GET",
    credentials: "include",
  })
    .then(async (response) => {
      const jsonResponse = await response.json();
      //console.log(jsonResponse);
      dataResponse = jsonResponse;
    })
    .catch((error) => console.error(error));
  return dataResponse;
};

export const getAddressFromString = async (address) => {
  logger.debug("This is the address sent to the backend - ", address);
  let dataResponse;
  await fetch(`${SERVER_URL}${API_VERSION}/locations/get-location-by-address?address=${address}`, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "GET",
    credentials: "include",
  })
    .then(async (response) => {
      dataResponse = await response.json();
      logger.debug("This is the data response - ", dataResponse);
    })
    .catch((error) => console.error(error));
  return dataResponse;
};

export const distanceBetweenTwoPoints = async (startPoint, endPoint) => {
  const R = 6371; // Earth radius in kilometers
  const { lat: lat1, lng: lon1 } = startPoint.latLng;
  const { lat: lat2, lng: lon2 } = endPoint.latLng;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  return distance;
};

const toRad = (degrees) => {
  return (degrees * Math.PI) / 180;
};
